import PropTypes from 'prop-types';
import React from 'react';
import reactT from './../components/reactT';
import FederatedSolrComponentPack from "./federated_solr_component_pack";
class FederatedSearchFieldContainer extends React.Component {
  constructor(props) {
    super(props);

    this.handleFiltersClick = this.handleFiltersClick.bind(this);
  }

  handleFiltersClick() {
    if (window.innerWidth  < 768) {
      document.body.classList.toggle('facet-filters-opened');
    }
  }

  render() {
    const {
      customComponents,
      onSearchFieldChange,
      onNewSearch,
      CurrentFacetsCounter
    } = this.props;
    const CurrentQueryComponent = customComponents.searchFields.currentQuery;
    return (
      <div className="search-filters">
        <div className="block-facet-filters-block">
          <div className="search-filters__form w-100 pb-0">
            <section className="search-accordion" aria-labelledby="section-title">
            <div className="accordion-filter">
              <div className="filter-mobile-toggler">
                <div onClick={this.handleFiltersClick}>
                <span className="facet-filters-label" id="section-title">{reactT('Filters')}</span>
                <img src="/themes/custom/unhcr_rw/images/icons/filler-icon.svg" alt="filters icon" className="filters-icon d-none d-md-block"/>
                <img src="/themes/custom/unhcr_rw/images/icons/filler-mobile-icon.svg" alt="filters icon" className="filters-icon d-md-none"/>
                </div>
                <img src="/themes/custom/unhcr_rw/images/icons/close-bg-primary.svg" alt="filters icon close" className="filters-icon-close" onClick={this.handleFiltersClick} />
              </div>
              <CurrentQueryComponent
                  {...this.props}
                  onChange={onSearchFieldChange}
                />
              <div><a href={window.location.pathname} className="reset-filter">{reactT('Reset all filters')}</a></div>
              </div>
              { this.props.resultsCount > 0
                ? (<div className={CurrentFacetsCounter >= 10 ? 'search-accordion__group disabled' : 'search-accordion__group'}>{this.props.children}</div>)
                : (<div className="search-accordion__group">{this.props.children[0]}
                <div className="search-filters__no-results pb-4">{reactT('There are no results to filter.')}</div></div>,window.scrollTo({ top: 0 }))
                 }
            </section>
          </div>
        </div>
      </div>
    );
  }
}

FederatedSearchFieldContainer.defaultProps = {
  customComponents: FederatedSolrComponentPack,
  searchFields: [
    {
      type: "text",
      field: "*",
    },
  ],
};

FederatedSearchFieldContainer.propTypes = {
  children: PropTypes.array,
  onNewSearch: PropTypes.func,
  customComponents: PropTypes.object,
};

export default FederatedSearchFieldContainer;
